<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    let p = this
    let beginTime = 0 // 开始时间
    let differTime = 0 // 时间差
    window.onunload = function () {
      differTime = new Date().getTime() - beginTime
      if (differTime <= 5) {
        p.$axios.post('/outLogingKonw', {
        })
      }
    }
    window.onbeforeunload = function () {
      beginTime = new Date().getTime()
    }
  }
}
</script>

<style lang="scss">
button{
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue